import { createSelector } from "reselect";

const selectAuthorized = (state) => state.authorized;

export const selectIsAuthorized = createSelector(
  [selectAuthorized],
  (authorized) => authorized.isAuthorized
);
